<template>
<div class="monitor-container">
    <Row type="flex" :gutter="9">
        <Col flex="1" >
        <Card class="card-container" dis-hover>
            <!--信号交互-->
            <div slot="title" class="card-title">{{ getTranslation('a184') }}</div>
            <Row type="flex" class="normal-hover" >
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a185') }}</div>
                    </Col>
                    <Col flex="1" >
                        <Select :transfer="true" class="input-field" size="small" v-model="localData.OptStartMode"
                        :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                        <Option v-for="(item, key) in OptStartModeList" :value="key" :key="key">{{ item }}</Option>
                        </Select>
                    </Col>
                </Row>
                </Col>
            </Row>
            <Row type="flex" class="normal-hover multi-row" >
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a186') }}</div>
                    </Col>
                    <Col flex="1" >
                        <i-switch class="switch-cls" size="large" :true-value="1" :false-value="0" v-model="CfgSysFunc1bit7"></i-switch>
                    </Col>
                </Row>
                </Col>
            </Row>
            <Row type="flex" class="normal-hover multi-row">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a187') }}</div>
                    </Col>
                    <Col flex="1" >
                        <Select :transfer="true" class="input-field" size="small" v-model="CfgSysFunc1bit6"
                        :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                        <Option v-for="(item, key) in CfgSysFunc1FinList" :value="key" :key="key">{{ item }}</Option>
                        </Select>
                    </Col>
                </Row>
                </Col>
            </Row>
            <Row type="flex" class="normal-hover multi-row">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a188') }}</div>
                    </Col>
                    <Col flex="1" >
                        <i-switch class="switch-cls" size="large" :true-value="1" :false-value="0" v-model="CfgSysFunc1bit10"></i-switch>
                    </Col>
                </Row>
                </Col>
            </Row>
            <Row type="flex" class="normal-hover multi-row">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a113') }}</div>
                    </Col>
                    <Col flex="1" >
                        <i-switch class="switch-cls" size="large" :true-value="1" :false-value="0" v-model="CfgSysFunc0bit15"></i-switch>
                    </Col>
                </Row>
                </Col>
            </Row>           
        </Card>
        </Col>

        <Col flex="1" >
        <Card class="card-container" dis-hover>
            <div slot="title" class="card-title">{{ getTranslation('a189') }}</div>
            <Row type="flex" class="normal-hover">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a190') }}</div>
                    </Col>
                    <Col flex="1" >
                        <Select :transfer="true" class="input-field" size="small" v-model="localData.OptPrsUnit"
                        :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
                        <Option v-for="(item, key) in OptPrsUnitList" :value="key" :key="key">{{ item }}</Option>
                        </Select>
                    </Col>
                </Row>
                </Col>
            </Row>
            <Row type="flex" class="normal-hover multi-row" >
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a191') }}</div>
                    </Col>
                    <Col flex="1" >
                         <InputNumber  size="small"  type="number" v-model="localData.ThrBoostAuto" />
                    </Col>
                </Row>
                </Col>
            </Row>
            
        </Card>
        </Col>

        <Col flex="1" >
        <Card class="card-container" dis-hover>
            <div slot="title" class="card-title">{{ getTranslation('a192') }}</div>
            <Row type="flex" class="normal-hover multi-row">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a193') }}</div>
                    </Col>
                    <Col flex="1" >
                        <InputNumber  size="small"  type="number" v-model="localData.TmContInterval" />
                    </Col>
                </Row>
                </Col>
            </Row>
            <Row type="flex" class="normal-hover multi-row">
                <Col flex="1">
                <Row type="flex"  :class="['row-odd' ]">
                    <Col flex="1" >
                    <div class="custom-label">{{ getTranslation('a194') }}</div>
                    </Col>
                    <Col flex="1" >
                        <InputNumber  size="small"  type="number" v-model="localData.TmCoolerIdleStop" />
                    </Col>
                </Row>
                </Col>
            </Row>
        
        </Card>
        </Col>   

    </Row>
    <Row>
        <Button type="primary" @click="handleSave">{{ getTranslation('c006') }}</Button>
    </Row>
</div>
</template>

<script>
import {
    mapGetters
} from 'vuex'
import { int16toBit, bitToInt16 } from '@/util/util'


export default {
    name: 'FunctonSetting',
    components: {},
    props: {
        systemData: {
            type: Object,
            default: function() { return {} }
        },
        mac: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            // 需要按位编辑的字段列表，后续新增字段只需追加到此数组
            bitFields: ["CfgSysFunc1","CfgSysFunc0",],
            // 原始值快照，保存时对比用
            originalData: {},
            // { HwAssy0: [0,1,0,...], HwAssy1: [...] }
            localBitsMap: {},
            // 需要本地副本的普通值字段（避免直接修改 prop），后续新增字段只需追加到此数组
            valueFields: ['OptStartMode', "OptPrsUnit","ThrBoostAuto","TmContInterval","TmCoolerIdleStop"],
            // 本地值副本 { HwValveTypePrePrs: val, hwValveTypeTrip: val }
            localData: {}
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
        CfgSysFunc0bit15: {
            get: function() { var b = this.localBitsMap['CfgSysFunc0']; return b ? b[15] : 0 },
            set: function(val) { var b = this.localBitsMap['CfgSysFunc0']; if (b) this.$set(b, 15, val ? 1 : 0) }
        },
       CfgSysFunc1bit6: {
            get: function() { var b = this.localBitsMap['CfgSysFunc1']; return b ? b[6] : 0 },
            set: function(val) { var b = this.localBitsMap['CfgSysFunc1']; if (b) this.$set(b, 6, val ? 1 : 0) }
        },
        CfgSysFunc1bit7: {
            get: function() { var b = this.localBitsMap['CfgSysFunc1']; return b ? b[7] : 0 },
            set: function(val) { var b = this.localBitsMap['CfgSysFunc1']; if (b) this.$set(b, 7, val ? 1 : 0) }
        },
        CfgSysFunc1bit10: {
            get: function() { var b = this.localBitsMap['CfgSysFunc1']; return b ? b[10] : 0 },
            set: function(val) { var b = this.localBitsMap['CfgSysFunc1']; if (b) this.$set(b, 10, val ? 1 : 0) }
        },
       
        OptStartModeList(){
            return [
                this.getTranslation('a041'),
                this.getTranslation('a040'),
                this.getTranslation('a195'),
            ]
        },
        CfgSysFunc1FinList(){
            return [
                this.getTranslation('k054'),
                this.getTranslation('k053'),
            ]
        },
        OptPrsUnitList(){
            return [               
                "MPa",
                "bar",
                "psi", 
                "kN",
                "lbf",           
            ]
        }
        
    },
    created() {
        var self = this
        this.bitFields.forEach(function(field) {
            self.$watch('systemData.' + field, function(newVal) {
                if (newVal != null) {
                    self.$set(self.localBitsMap, field, int16toBit(newVal))
                    self.$set(self.originalData, field, newVal)
                }
            }, { immediate: true })
        })
        this.valueFields.forEach(function(field) {
            self.$watch('systemData.' + field, function(newVal) {
                self.$set(self.localData, field, newVal)
                self.$set(self.originalData, field, newVal)
            }, { immediate: true })
        })
    },
    methods: {
        handleSave() {
            var payload = {}
            var self = this
            this.bitFields.forEach(function(field) {
                var bits = self.localBitsMap[field]
                if (!bits) return
                var newVal = bitToInt16(bits)
                if (newVal !== self.originalData[field]) {
                    payload[field] = newVal
                }
            })
            this.valueFields.forEach(function(field) {
                var newVal = self.localData[field]
                if (newVal != null && newVal !== self.originalData[field]) {
                    payload[field] = newVal
                }
            })
            if (Object.keys(payload).length > 0) {
                this.$emit('save', payload)
            }else {
                 this.$Message.error(this.getTranslation('a159'))
            }
        }
    },
}
</script>

<style scoped>
@import url('../../../../assets/style/list.css');
@import url('../../../../assets/style/tab.css');
.multi-row{
    margin-top:10px;
}

</style>
